import InfoVM from './info-vm';
import PortfolioGalleryVM from './portfolio-gallery-vm';
import CertificateGalleryVM from './certificate-gallery-vm';
import BadgeGalleryVM from './badge-gallery-vm';

export default function UserProfileViewModel(data, $el) {
  const self = this;

  self.userInfoVM;
  self.portfolioVM;
  self.certificatesVM;
  self.badgesVM;

  const editParam = Kadenze.Util.getParameterByName('edit');

  self.editMode = ko.observable(editParam && editParam == 'true');
  self.nameEditing = ko.observable(false);
  self.nicknameEditing = ko.observable(false);
  self.bannerEditing = ko.observable(false);

  self.bannerEditing.subscribe(function (value) {
    if (value)
      setTimeout(self.initProfileBannerDZ, 300);
  });

  self.profile = ko.observable();

  self.selectedSocial = ko.observable(null);

  const socialMapping = ko.observableArray([
    {id: 'website', name: 'Website', prefix: 'http://', cssclass: 'kf-link'},
    {id: 'facebook', name: 'Facebook', prefix: 'https://facebook.com/', cssclass: 'kf-social-facebook-circle'},
    {id: 'twitter', name: 'Twitter', prefix: 'https://twitter.com/', cssclass: 'kf-social-twitter-circle'},
    {id: 'instagram', name: 'Instagram', prefix: 'https://instagram.com/', cssclass: 'kf-social-instagram-circle'},
    {id: 'linkedin', name: 'LinkedIn', prefix: 'https://linkedin.com/in/', cssclass: 'kf-social-linkedin-circle'},
    {id: 'pinterest', name: 'Pinterest', prefix: 'https://pinterest.com/', cssclass: 'kf-social-pintrest-circle'},
    {id: 'soundcloud', name: 'SoundCloud', prefix: 'https://soundcloud.com/', cssclass: 'kf-social-soundcloud-circle'},
    {id: 'tumblr', name: 'Tumblr', prefix: 'https://', cssclass: 'kf-social-tumblr-circle'},
    {id: 'vimeo', name: 'Vimeo', prefix: 'https://vimeo.com/', cssclass: 'kf-social-vimeo-circle'},
    {id: 'youtube', name: 'YouTube', prefix: 'https://youtube.com/user/', cssclass: 'kf-social-youtube-circle'},
    {id: 'github', name: 'GitHub', prefix: 'https://github.com/', cssclass: 'kf-social-github-circle'}
  ]);

  self.bindData = function(data) {
    self.profile(ko.mapping.fromJS(data).profile);
    self.profile().first_name.extend({required: true});
    self.profile().last_name.extend({required: true});
    self.profile().nickname.extend({required: true});
    self.initProfileDZ();
  };

  self.editToggle = function(newVal) {
    if (self.portfolioVM) {
      if (newVal) {
        self.portfolioVM.initSortable();
      } else {
        self.portfolioVM.disableSortable();
      }
    }

    if (self.certificatesVM) {
      if (newVal) {
        self.certificatesVM.initSortable();
      } else {
        self.certificatesVM.disableSortable();
      }
    }

    if (!newVal) {
      self.bannerEditing(false);
      if (self.nameEditing() || self.nicknameEditing()) {
        self.saveName();
      }
      if (self.selectedSocial()) {
        self.saveSocial();
      }
    }
  };

  self.isDisplayable = function(input) {
    return input != null && input.trim() != '';
  };

  self.projectTitleWithDraftStatus = function(title,status) {
    return (status != 'draft') ? title : title + ' (draft)';
  };

  self.editMode.subscribe(self.editToggle);

  self.toggleEditProfile = function () {
    self.editMode(!self.editMode());
  };

  self.editBanner = function () {
    self.bannerEditing(true);
  };

  self.editSocial = function(item) {
    self.selectedSocial(item);
  };

  self.saveSocial = function() {
    const social_info = ko.mapping.toJS(self.profile().social_info);
    const data = {user: {social_info_attributes: social_info}};
    self.save(data);
    self.selectedSocial(null);
  };

  self.objForSocial = function(key) {
    return _.find(socialMapping(), function (item) {
      return item.id === key;
    });
  };

  self.socialIconCls = function(val) {
    const obj = self.objForSocial(val);
    return obj && obj.cssclass || '';
  };

  self.prefixForSocial = ko.computed(function() {
    if (self.selectedSocial()) {
      const obj = self.objForSocial(self.selectedSocial().key);
      return obj && obj.prefix;
    }
    return '';
  });

  self.selectedSocialInputVal = ko.pureComputed({
    read: function() {
      if (self.selectedSocial()) {
        const obj = self.objForSocial(self.selectedSocial().key);
        return obj && self.selectedSocial().value() && self.selectedSocial().value().replace(obj.prefix, '');
      }
      return '';
    },
    write: function(val) {
      if (self.selectedSocial()) {
        const obj = self.objForSocial(self.selectedSocial().key);
        if (obj) {
          if (val && val.trim() != '') {
            self.selectedSocial().value(obj.prefix + val);
          }
          else {
            self.selectedSocial().value(null);
          }
        } else {
          self.selectedSocial().value(val);
        }
      }
    }
  });

  self.full_name = ko.pureComputed({
    read: function() {
      let str = '';
      if (self.profile()) {
        if (self.profile().first_name()) {
          str += self.profile().first_name();
        }
        if (self.profile().last_name()) {
          str += ' ' + self.profile().last_name();
        }
      }
      return str;
    },
    write: function(val) {
      const parts = _.compact(val.split(/\s+/));
      if (parts.length == 0) {
        self.profile().first_name('');
        self.profile().last_name('');
      }
      else {
        self.profile().first_name(parts[0]);
      }
      if (parts.length > 1) {
        self.profile().last_name(parts.splice(1).join(' '));
      }
      else {
        self.profile().last_name('');
      }
    }
  });

  ko.validation.rules['fullName'] = {
    validator: function (val) {
      return val.split(/\s+/).length > 1;
    },
    message: 'Please enter a first and last name'
  };
  ko.validation.registerExtenders();

  self.full_name.extend({fullName: true});

  self.editName = function() {
    self.nameEditing(true);
  };

  self.editNickname = function() {
    self.nicknameEditing(true);
  };

  self.saveName = function() {
    const data = {
      user: {
        first_name: self.profile().first_name(),
        last_name: self.profile().last_name(),
        nickname: self.profile().nickname()
      }
    };

    self.client_errors = ko.validation.group([self.full_name, self.profile().first_name, self.profile().last_name, self.profile().nickname]);

    if (self.client_errors().length === 0) {
      self.save(data);
      self.nameEditing(false);
      self.nicknameEditing(false);
    }
    else {
      self.client_errors.showAllMessages();
    }
  };

  self.initProfileDZ = function() {
    const $el = $('#profile-avatar-dz');
    const url = Kadenze.Routes.users_path();

    const message = JST['templates/dropzone-avatar']({
      title: Kadenze.I18n.t('profile.image.dropzone.upload_avatar'),
      previewable: true,
      maxFilesize: Kadenze.I18n.t('profile.image.dropzone.max_file_size'),
      dimensions: Kadenze.I18n.t('profile.image.dropzone.dimensions')
    });

    let curFileObj;
    const imgPath = self.profile().avatar.thumb.url();
    if (imgPath && imgPath != '') {
      curFileObj = {
        path: imgPath
      };
    }

    const options = {
      method: 'PUT',
      autoProcessQueue: false,
      acceptedFiles: '.jpeg,.jpg,.png',
      dzPreview: JST['templates/dropzone-avatar-preview']({previewable: true}),
      paramName: 'user[avatar]',
      thumbnailHeight: 300,
      thumbnailWidth: 300,
      cropOptions: {
        modalId: 'crop_modal',
        aspectRatio: 1
      }
    };

    try { if(Dropzone.forElement('#' + $el.attr('id'))) { return; } }
    catch(err) { }

    const callbacks = {
      sending: function (file, xhr, formData) {
        formData.append('user[id]', self.profile().id());
        Kadenze.UIUtil.showLoadingIndicator(self.$el);
      },
      success: function (file, response) {
        self.profile().avatar.thumb.url(URL.createObjectURL(file))
      },
      error: function (file, errorMessage) {
        Kadenze.UIUtil.showNotice(self.$el, {message: errorMessage, status: 'error'}, 3000);
      },
      complete: function (file) {
        Kadenze.UIUtil.hideLoadingIndicator(self.$el);
      },
      removedfile: function (file) {
        const response = self.save({user: {remove_avatar: true}});
        response.done(function () {
          self.profile().avatar.thumb.url(self.profile().default_image());
        });
      }
    };

    new Kadenze.ImageDropZone($el, message, url, callbacks, curFileObj, options);
  };

  self.initProfileBannerDZ = function() {
    const $el = $('#profile-banner-dz');
    const url = Kadenze.Routes.users_path();

    const message = JST['templates/dropzone-generic']({
      previewable: false,
      maxFilesize: 2,
      dimensions: '1440px wide',
      dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
      dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
      browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
      dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
      maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
      fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
      optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
    });

    const options = {
      method: 'PUT',
      autoProcessQueue: false,
      acceptedFiles: '.jpeg,.jpg,.png',
      previewTemplate: '<span></span>',
      paramName: 'user[banner]',
      cropOptions: {
        modalId: 'crop_modal',
        aspectRatio: 6.8
      }
    };

    try { if(Dropzone.forElement('#' + $el.attr('id'))) { return; } }
    catch(err) { }

    const callbacks = {
      sending: function (file, xhr, formData) {
        formData.append('user[id]', self.profile().id());
        Kadenze.UIUtil.showLoadingIndicator(self.$el);
      },
      success: function (file, response) {
        self.profile().banner.url(URL.createObjectURL(file));
        self.profile().banner_uploaded(true);
        self.bannerEditing(false);
      },
      error: function (file, errorMessage) {
        Kadenze.UIUtil.showNotice(self.$el, {message: errorMessage, status: 'error'}, 3000);
      },
      complete: function (file) {
        Kadenze.UIUtil.hideLoadingIndicator(self.$el);
      },
      removedfile: function (file) {
        self.profile().remove_banner = true;
      }
    };

    new Kadenze.ImageDropZone($el, message, url, callbacks, null, options);
  };

  self.removeBanner = function () {
    const response = self.save({user: {remove_banner: true}});
    response.done(function () {
      self.profile().banner.url(self.profile().default_banner());
    });
  };

  self.initTabs = function() {
    const hash = window.location.hash.substr(1);

    if (hash.length > 0) {
      $('li.min-tab__tab a[href="#' + hash + '"]').tab('show');
    }else{
      $('li.min-tab__tab:first-child a').tab('show');
    }

    $('window').scrollTop();
  };

  self.save = function (data) {
    const request = new Kadenze.AjaxRequest({
      type: 'PUT',
      url: Kadenze.Routes.users_path(),
      data: data,
      loadingIndicator: true
    });

    request.success((res, status) => {
      new Kadenze.Notice.success({message: res["message"]});
    });

    request.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.message;
        new Kadenze.Notice.error({message: msg});
      }
    });

    return request;
  };

  this.promptToCreateProjects = ko.pureComputed(() => {
    return !this.portfolioVM.projects().length &&
      this.profile().editable &&
        !this.editMode();
  });

  this.shareContent = projectIsDraft => {
    return projectIsDraft ? I18n.t('dict.publish_to_share') : I18n.t('dict.share');
  };

  const __construct = function(that) {
    // Set up the child viewmodels
    const user_profile_data = JSON.parse($('#user_profile_json').val());
    self.userInfoVM = new InfoVM(user_profile_data);

    const portfolio_data = JSON.parse($('#projects_json').val());
    self.portfolioVM = new PortfolioGalleryVM(portfolio_data);

    const certificate_data = JSON.parse($('#certificates_json').val());
    self.certificatesVM = new CertificateGalleryVM(certificate_data);

    const badge_data = JSON.parse($('#badges_json').val() || '[]');
    self.badgesVM = new BadgeGalleryVM(badge_data);

    that.bindData(data);
    that.initTabs();
  }(this);
}
